<!--
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-16 14:50:50
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-30 15:36:39
-->

<template>
	<div class="pages-finish">
		<div class="body">
			<el-row>
				<el-col class="left-col" :class="{ active: tab === 'left' }" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="left" :class="this.$i18n.locale">
						<div class="logo" :class="this.$i18n.locale">
							<img :src="
									require(`../assets/pc-change-images/upload-logo-${this.$i18n.locale}.png`)
								" alt="#" />
						</div>
						<div class="submit-img" :class="this.$i18n.locale">
							<img :src="
									require(`../assets/finish/left-submit-${this.$i18n.locale}.png`)
								" alt="#" />
						</div>
						<div class="back" :class="this.$i18n.locale">
							<img @click="goPageList()" :src="
									require(`../assets/pc-change-images/finish-backListBtn-${this.$i18n.locale}.png`)
								" alt="#" />
						</div>
					</div>
				</el-col>
				<el-col class="right-col" :class="{ active: tab === 'right' }" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="mobile-logo">
						<img :src="
								require(`../assets/pc-change-images/upload-logo-${this.$i18n.locale}.png`)
							" alt="#" />
					</div>
					<div class="right">
						<div class="bg-wrapper">
							<img class="right-top" :src="require(`../assets/finish/right-top.png`)" alt />
							<img class="left-bottom" :src="require(`../assets/finish/left-bottom.png`)" alt />
							<div class="logo" :class="this.$i18n.locale">
								<img class="title" :src="
										require(`../assets/pc-change-images/list-logo-${this.$i18n.locale}.png`)
									" alt="#" />
							</div>
							<div class="work-creator">{{ name }}</div>
							<div class="label-img">
								<img :src="
										require(`../assets/finish/right-label-${this.$i18n.locale}.png`)
									" alt="#" />
							</div>
							<div class="code2">
								<!-- <img :src="require(`../assets/finish/code2.png`)" alt="#" /> -->
								<div id="qrCode" ref="qrCodeDiv"></div>
							</div>
							<div class="code2-label">
								<img src="../assets/logoFour.png" alt="#" />
							</div>
						</div>
					</div>
					<div class="close" @click="tab = 'left'">X</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
	name: 'PagesFinish',
	data() {
		return {
			tab: 'right',
			name: 'XXXXX'
		}
	},
	computed: {
		isMobile() {
			if (
				navigator.userAgent.match(
					/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
				)
			) {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		goPageList() {
			this.$router.push({ name: 'PagesWorks' })
		},
		bindQRCode() {
			const size = this.isMobile ? 46 : 46
			new QRCode(this.$refs.qrCodeDiv, {
				text: 'https://olympics.sinorusfocus.com',
				width: size,
				height: size,
				colorDark: '#000', //二维码颜色
				colorLight: '#ffffff', //二维码背景色
				correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
			})
		}
	},
	mounted() {
		if (this.$route.query) {
			this.name = this.$route.query.name
		}
		if (localStorage.getItem('lang')) {
			this.$i18n.locale = localStorage.getItem('lang')
		}
		this.$nextTick(() => {
			this.bindQRCode()
		})
	}
}
</script>

<style lang="stylus">
.pages-finish {
  min-height: 100vh;
  width: 100vw;
  position: relative;
  background: url('../assets/finish/bg.png') no-repeat;
  background-size: cover;
  padding: 30px 0;
  box-sizing: border-box;

  .body {
    width: 60%;
    margin: 0 auto;
    border-radius: 20px;
    background-color: rgba(171, 173, 226, 0.6);

    .close {
      display: none;
    }

    .left {
      padding: 30px;

      .logo {
        width: 60%;
        margin: 0 auto;

        &.en {
          width: 80%;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .submit-img {
        width: 60%;
        margin: 80px auto 0;

        &.en {
          width: 80%;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .back {
        width: 120px;
        cursor: pointer;
        margin: 70px auto 0;

        &.en {
          width: 75%;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .mobile-logo {
      display: none;
      width: 90%;
      margin: 0 auto 20px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .right {
      background-color: #ffffff;
      border-radius: 10px;
      position: relative;
      height: 600px;

      .bg-wrapper {
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: 12px;
        top: 12px;
        background: url('../assets/finish/right-bg.png') no-repeat;
        background-size: cover;
        padding-top: 40px;

        .right-top {
          width: 100px;
          position: absolute;
          right: -30px;
          top: -30px;
        }

        .left-bottom {
          width: 100px;
          position: absolute;
          left: -40px;
          bottom: -40px;
        }

        .logo {
          width: 40%;
          margin: 0 auto;

          &.en {
            width: 60%;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .work-creator {
          width: 70%;
          margin: 0 auto;
          text-align: center;
          color: #ffffff;
          font-size: 20px;
          margin-top: 20px;
          border-bottom: 1px solid #fff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .label-img {
          width: 70%;
          margin: 0 auto;
          margin-top: 70px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .code2-label {
          width: 90%;
          margin: 12px auto 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .code2 {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 30px auto 0;
          background-image: url('../assets/finish/code2.png');
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;

          #qrCode {
            margin-top: 8px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .pages-finish {
    .body {
      width: 90%;
      padding: 12px;
      height: 90%;

      .mobile-logo {
        display: block !important;
      }

      .right {
        height: 580px;
        .bg-wrapper {
          background-size: 100% 100% !important
        }
      }

      .close {
        margin: 0 auto;
        margin-top: 20px;
        display: block !important;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: #eb6877;
        font-size: 30px;
        font-weight: 700;
        border-radius: 10px;
      }

      .left-col {
        display: none;

        &.active {
          display: block;
        }

        .left {
          &.en {
            padding: 20px !important;
          }

          .logo {
            width: 100%;
          }

          .submit-img {
            width: 100%;
          }

          .back {
            width: 140px;
            cursor: pointer;
            margin: 170px auto 0;

            &.en {
              width: 100% !important;
            }
          }
        }
      }

      .left-bottom {
        width: 80px !important;
        position: absolute;
        left: -40px;
        bottom: -40px;
      }

      .right-col {
        display: none;

        &.active {
          display: block;
        }
      }
    }
  }
}
</style>
